import React, { ReactElement } from "react";
import FormSection from "@components/antiviruschoice/formSection";
import ContactTop from "@components/antiviruschoice/contactTop";
import { GetServerSideProps } from "next";
import AntiVirusChoiceWrapper from "@components/layouts/antiVirusChoiceWrapper";
import { getPageProps } from "@services/initial-calls";

const ContactPage: ReactElement = () => {
    return (
        <AntiVirusChoiceWrapper>
            <div className="bg-white">
                <ContactTop />
            </div>
            <FormSection />
        </AntiVirusChoiceWrapper>
    );
};
export default ContactPage;
export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", { pageTitle: "Contact Us" });
};
